import React from "react";

import { Pagination as RaPagination, PaginationProps } from "ra-ui-materialui";

export const DefaultPagination = (props: PaginationProps) => <RaPagination
  {...props}
  rowsPerPageOptions={[10, 25, 50, 100]}
/>;
